import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectComponentsRoute: InvariantJiraRoute = {
	name: 'project-components',
	/**
	 * Note: The below route.path is incompatible with order-independent routing.
	 * A special workaround has been implemented in @atlassian/match-route to handle this route.path.
	 * Therefore, disabling `jira/route-definitions/route-standards` is safe.
	 * However, we'll remove the workaround in a future update.
	 */
	// eslint-disable-next-line jira/route-definitions/route-standards
	path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components',
};
